export class OsaStaffPortalModel {
  GetArticleTrackingList: string = "";
  GetStarterXMLData: string = "";
}
